export default [
  {
    title: 'Cadastros',
    icon: 'PlusCircleIcon',
    action: 'read',
    resource: 'Cadastros',
    children: [
      {
        title: 'Gerais',
        action: 'read',
        resource: 'Gerais',
        children: [
          {
            title: 'Portador',
            route: 'apps-portador-list',
            action: 'read',
            resource: 'Portador',

          },
          {
            title: 'País',
            route: 'apps-pais-list',
            action: 'read',
            resource: 'Pais',

          },
          {
            title: 'Cidade',
            route: 'apps-cidade-list',
            action: 'read',
            resource: 'Cidade',

          },
          {
            title: 'UF',
            route: 'apps-uf-list',
            action: 'read',
            resource: 'Uf',
          },

          {
            title: 'Tipo Endereço',
            route: 'apps-tipo-endereco-list',
            action: 'read',
            resource: 'TipoEndereco',

          },
          {
            title: 'Banco',
            route: 'Banco',
            action: 'read',
            resource: 'Banco',

          },
        ],
      },
      {
        title: 'Informações Organizacionais',
        action: 'read',
        resource: 'InfoOrganizacionais',
        children: [
          {
            title: 'Unidades de Negócio',
            route: 'cadastros-unidade-negocio-list',
            action: 'read',
            resource: 'UnidadeNegócio',
          },
          {
            title: 'Empresa',
            route: 'apps-empresa-list',
            action: 'read',
            resource: 'Empresa',
          },
          {
            title: 'Canais de Venda',
            route: 'apps-canal-venda-list',
            action: 'read',
            resource: 'CanalVenda',
          },
          {
            title: 'Estabelecimento',
            route: 'apps-estabelecimento-list',
            action: 'read',
            resource: 'Estabelecimento',
          },
          {
            title: 'Transportadora',
            route: 'apps-transportadora-list',
            action: 'read',
            resource: 'Transportadora',
          },
        ],
      },
      {
        title: 'Produtos',
        action: 'read',
        resource: 'Produtos',
        children: [
          {
            title: 'Unidade de Medida',
            route: 'apps-unidade-medida-list',
            action: 'read',
            resource: 'UnidadeMedida',

          },
          {
            title: 'Grupo Estoque',
            route: 'apps-grupo-estoque-list',
            action: 'read',
            resource: 'GrupoEstoque',

          },
          {
            title: 'Família Comercial',
            route: 'apps-familia-comercial-list',
            action: 'read',
            resource: 'FamiliaComercial',

          },
          {
            title: 'Família Material',
            route: 'apps-familia-material-list',
            action: 'read',
            resource: 'FamiliaMaterial',

          },
          {
            title: 'Item',
            route: 'apps-item-list',
            action: 'read',
            resource: 'Item',
          },
          {
            title: 'Estoque',
            route: 'apps-estoque-list',
            icon: 'PackageIcon',
            action: 'read',
            resource: 'Item',
          },
        ],
      },
      {
        title: 'Apoio a Vendas',
        action: 'read',
        resource: 'ApoioVendas',
        children: [
          {
            title: 'Tipo Tabela',
            route: 'apps-tipo-tabela-list',
            action: 'read',
            resource: 'TipoTabela',
          },
          {
            title: 'Alçada',
            route: 'apps-alcada-list',
            action: 'read',
            resource: 'Alcada',
          },
          {
            title: 'Tipo Pic',
            route: 'apps-tipo-pic-list',
            action: 'read',
            resource: 'TipoPic',
            tenantPref: 'picAtivo',
          },
          {
            title: 'Pic Regra',
            route: 'apps-pic-regra-list',
            action: 'read',
            resource: 'PicRegra',
            tenantPref: 'picAtivo',
          },
          {
            title: 'Representantes',
            route: 'apps-representante-list',
            action: 'read',
            resource: 'Representantes',
          },
          {
            title: 'Representante X Condição de Pagamento',
            route: 'apps-repres-cond-pagto-list',
            action: 'read',
            resource: 'RepresentantesXCondicaoPagamento',
          },
          {
            title: 'Hierarquia de Representantes',
            route: 'hierarquia-representantes',
            action: 'read',
            resource: 'HierarquiaRepresentantes',
          },
        ],
      },
      {
        title: 'Fiscal e Financeiro',
        action: 'read',
        resource: 'FiscalFinanceiro',
        children: [
          {
            title: 'Condição Pagamento',
            route: 'apps-condicao-pagamento-list',
            action: 'read',
            resource: 'CondicaoPagamento',

          },
          {
            title: 'Natureza Operação',
            route: 'apps-natureza-operacao-list',
            action: 'read',
            resource: 'NaturezaOperação',

          },
          {
            title: 'Classificação Fiscal',
            route: 'apps-classificacao-fiscal-list',
            action: 'read',
            resource: 'ClassificacaoFiscal',

          },
          {
            title: 'Tipo Pedido',
            route: 'apps-tipo-pedido-list',
            action: 'read',
            resource: 'TipoPedido',

          },
          {
            title: 'Tipo Pedido X Estabelecimento',
            route: 'apps/tipo-pedido-estabelecimento/list',
            action: 'read',
            resource: 'TipoPedidoXEstabelecimento',

          },
        ],
      },
      {
        title: 'Cadastros',
        action: 'read',
        resource: 'MenuCliente',
        children: [
          {
            title: 'Grupo Comercial',
            route: 'apps-grupo-comercial-list',
            action: 'read',
            resource: 'GrupoComercial',
          },
          {
            title: 'Cliente',
            route: 'apps-cliente-list',
            action: 'read',
            resource: 'Cliente',
          },
          {
            title: 'Cliente X Tipo Pedido',
            route: 'apps-cliente-tipo-pedido-list',
            action: 'read',
            resource: 'ClienteXTipoPedido',
          },
        ],
      },
      {
        title: 'Comunicado',
        action: 'read',
        resource: 'MenuComunicado',
        children: [
          {
            title: 'Tipo Comunicado',
            route: 'apps-tipo-comunicado-list',
            action: 'read',
            resource: 'TipoComunicado',
          },
          {
            title: 'Mural de Comunicados',
            route: 'apps-comunicado-list',
            action: 'manage',
            resource: 'Comunicado',
          },
        ],
      },
      {
        title: 'Imagens',
        route: 'template-imagem-list',
        action: 'read',
        resource: 'Imagens',
      },
      // {
      //     title: 'Imagens Home',
      //     route: 'imagens-home-list',
      //     action: 'read',
      //     resource: 'ImagensHome'
      // },
    ],
  },
];
